export const userAccessManagementTabs: IUserAccessManagementTabs = {
  permissionRoles: 'Permission Roles',
  users: 'Users',
};

export interface IUserAccessManagementTabs {
  permissionRoles: string;
  users: string;
};
